export default {
    auth: {
        accessData: {
            access_token: '',
            expires_in: '',
            refresh_token: '',
            scope: null,
            token_type: '',
        },
        changePassword: {
          data: {
            password: '',
            repeatPassword: '',
          },
          error: false,
          loading: false,
        },
        changePasswordSend: {
          data: {
            email: '',
          },
          error: false,
          loading: false,
        },
        login: {
            data: {
                password: '',
                username: '',
            },
            error: false,
            errorFromToken: false,
            loading: false,
        },
    },
    user: {
        info: {
            data: {},
            error: false,
            loading: false,
        },
        activate: {
            error: false,
            loading: false,
            success: false,
        },
        edit: {
            name: '',
            email: '',
            enabled: true,
            deleted: false,
            paying: false
        },
        reset: {
            error: false,
            loading: false,
            success: false,
        },
        undelete: {
            error: false,
            loading: false,
            success: false,
        },
        update: {
            data: {},
            error: false,
            loading: false,
            success: false
        },
        payee: {
            error: false,
            loading: false,
            success: false,
        },
        admin: {
            error: false,
            loading: false,
            success: false,
        },
        list: {
            data: [],
            error: false,
            loading: false,
        },
        admins: {
            data: [],
            error: false,
            loading: false,
        },
    },
    devices: {
        data: {
            error: false,
            list: [],
            loading: false,
        },
        toggle: {
            error: false,
            loading: false,
            success: false,
        },
        togglePublic: {
            error: false,
            loading: false,
            success: false,
        },
        update: {
            error: false,
            loading: false,
            success: false,
        },
        recipients: {
            error: false,
            loading: false,
            success: false,
            list: [],
        },
        current: null,
    },
    areas: {
        data: {
            error: false,
            list: [],
            loading: false,
            success: false,
        },
        update: {
            error: false,
            loading: false,
            success: false,
        },
        remove: {
            error: false,
            loading: false,
            success: false,
        },
        add: {
            error: false,
            loading: false,
            success: false,
        },
        currentArea: {
            error: false,
            loading: false,
            success: false,
            data: [],
        },
        current: null,
    },
    modals: [],
}



// WEBPACK FOOTER //
// ./src/reducers/initialState.js